/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableModeStruct {
  field ? : string;
  backgroundColor ? : number;
  image ? : Asset;
}
export default interface GridLayout {
  column: any;
  switchableMode ? : switchableModeStruct;
  displayMode: string;
  flexibleLayout: string;
  roundedBorder: boolean;
  shadow: boolean;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  column: Object,
  switchableMode: Object as() => switchableModeStruct,
  displayMode: String,
  flexibleLayout: String,
  roundedBorder: Boolean,
  shadow: Boolean,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  column: Object,
  switchableMode: Object as() => switchableModeStruct,
  displayMode: String,
  flexibleLayout: String,
  roundedBorder: Boolean,
  shadow: Boolean,
  dataABId: String,
  metadata: Object,
}

export class GridLayoutBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class GridLayoutInstance implements GridLayout {
      switchableMode ? : switchableModeStruct;
      displayMode: string;
      flexibleLayout: string;
      roundedBorder: boolean;
      shadow: boolean;
      dataABId ? : string;
      column: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchableMode) {
          if (typeof this.switchableMode.image === 'object') {
            this.switchableMode.image = {
              ...this.switchableMode.image,
              link: this.switchableMode.image['@link'],
              name: this.switchableMode.image['@name'],
              path: this.switchableMode.image['@path'],
            };
          } else {
            this.switchableMode.image = null as any;
          }
        }
      }
    }
    return new GridLayoutInstance(props);
  }
}
